import { render, staticRenderFns } from "./catalogos.vue?vue&type=template&id=1b22cf5c&scoped=true&"
import script from "./catalogos.vue?vue&type=script&lang=js&"
export * from "./catalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22cf5c",
  null
  
)

export default component.exports